import NavLinks from './Navlinks'
import './Navbar.css'
const Navigation = () => {
  return (
    <nav className="Navigation">
      <NavLinks />
    </nav>
  )
}

export default Navigation
